// extracted by mini-css-extract-plugin
module.exports = {"image":"_3sc9mEYC"};